import React, { useContext } from 'react'
import { Modal } from 'oio-react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { objectSettingsDisplayModes } from 'config/constants/ui'
import ObjectSettings from 'src/sites/kits/ObjectSettings'
import ModalRoute from 'src/sites/kits/Utils/ModalRoute'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import DiscussionSettings from './DiscussionSettings'
import EventSettings from './EventSettings'
import GroupSettings from './GroupSettings'

// TODO: This whole component is dumb and should be deprecated in short order
// PR #967
const TmpObjectSettingsRoute = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   if (!initiative.currentUserCanEdit) {
      return null
   }

   // Discussions have inline images and can have attached files
   if (initiative.class === 'discussion') {
      return (
         <ModalRoute path={`${match.path}/-/settings`}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <Modal
                  borderRadius="3px"
                  overlayBackgroundColor="rgba(45,40,40,0.9)"
                  width="100%[a-b] 90%[c-d] 100%[e-f]"
                  height="100%"
                  maxWidth="1000px"
                  onCloseComplete={onCloseComplete}
                  open={open}>
                  <DiscussionSettings returnUrl={match.url} />
               </Modal>
            )}
         </ModalRoute>
      )
   }

   if (initiative.class === 'post') {
      return (
         <ModalRoute path={`${match.path}/-/settings`}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <ObjectSettings.Modal
                  width="100%[a-b] 90%[c-d] 100%[e-f]"
                  height="100%"
                  maxWidth="1000px"
                  onCloseComplete={onCloseComplete}
                  onCloseTrigger={onCloseTrigger}
                  open={open}>
                  <ObjectSettings.Editor
                     descriptionInputMinHeight="300px"
                     displayMode={objectSettingsDisplayModes.DOUBLE_COLUMN}
                     editorToolbarConfig="advanced"
                     elements={[
                        'coverMedia',
                        'description',
                        'publishDate',
                        'slug',
                        'subtitle',
                        'tags'
                     ]}
                     nameInputStyle={{
                        fontSize: '20px',
                        fontWeight: '500'
                     }}
                     onCancelButtonClick={onCloseTrigger}
                     onUpdate={() => history.push(match.url)}
                  />
               </ObjectSettings.Modal>
            )}
         </ModalRoute>
      )
   }

   if (initiative.class === 'event') {
      return (
         <ModalRoute path={`${match.path}/-/settings`}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <Modal
                  borderRadius="3px"
                  overlayBackgroundColor="rgba(45,40,40,0.9)"
                  height="100%"
                  width="100%[a-b] 90%[c-d] 1000px[e-f]"
                  onCloseComplete={onCloseComplete}
                  onCloseTrigger={onCloseTrigger}
                  open={open}>
                  <EventSettings returnUrl={match.url} />
               </Modal>
            )}
         </ModalRoute>
      )
   }

   // Default: For groups, legacy resources
   return (
      <ModalRoute path={`${match.path}/-/settings`}>
         {({ open, onCloseComplete, onCloseTrigger }) => (
            <Modal
               borderRadius="3px"
               overlayBackgroundColor="rgba(45,40,40,0.9)"
               height="100%"
               width="100%[a-b] 90%[c-d] 1000px[e-f]"
               onCloseComplete={onCloseComplete}
               onCloseTrigger={onCloseTrigger}
               open={open}>
               <GroupSettings returnUrl={match.url} />
            </Modal>
         )}
      </ModalRoute>
   )
}

export default TmpObjectSettingsRoute
